import Vue from "vue"
import VueHtml2Canvas from "vue-html2canvas"
import "regenerator-runtime/runtime"

Vue.use(VueHtml2Canvas)